import styled from '@emotion/styled';
import { CardItemContainer as CardItemContainerComponent, Section } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const SectionWithMargin = styled(Section)<{ topMargin: boolean }>`
  ${(props) =>
    props.topMargin &&
    `
  ${mediaQuery('medium', 'min')} {
  margin-top: 100px;
  }
`}
`;

export const SideContentWrapper = styled.div`
  padding: 25px;
  padding-top: 0;
  position: relative;
`;

export const SideContentHeader = styled.div<{ enableWhatsAppContact?: boolean }>`
  background: ${(props) =>
    props.enableWhatsAppContact
      ? props.theme.color.green.whatsapp
      : props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  border-radius: 10px 10px 0 0;
  margin: -1px -26px 10px;
  padding: 5px 25px;
  position: relative;
  display: flex;
  align-items: center;
  min-height: 60px;

  &::after {
    border-color: ${(props) =>
      props.enableWhatsAppContact
        ? '#25d366 transparent transparent;'
        : '#ffCC01 transparent transparent'}
    border-style: solid;
    border-width: 6px 6px 0;
    bottom: -6px;
    content: '';
    display: block;
    height: 0;
    left: 50%;
    margin-left: -6px;
    margin-top: 0;
    position: absolute;
    top: auto;
    transform: rotate(1turn);
    width: 0;
  }
`;

export const SideContentTitle = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  font-size: 18px;
  font-weight: 600;
  text-align: center;
  width: 100%;

  ${mediaQuery('tablet')} {
    font-size: 16px;
  }
`;

export const CardItemContainer = styled(CardItemContainerComponent)`
  height: max-content;
  align-items: stretch;
  margin: 0 -15px;
`;

export const CardItemWrapper = styled.div`
  padding: 15px;
  width: 50%;
  min-height: 350px;
  ${mediaQuery('phone')} {
    width: 100%;
  }
`;

export const AwarenessBannerWrapper = styled.div`
  margin-top: 75px;
`;

export const ReviewWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const ReviewText = styled.div`
  font-size: 14px;
  margin-left: 4px;
  font-weight: 400;
  color: ${(props) => props.theme.color.medium.default};
`;

export const VerticalMargin = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
`;

export const SocialButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
`;

export const TranslateButtonContainer = styled.div`
  margin-bottom: 15px;
  width: fit-content;
`;
